import { render, staticRenderFns } from "./EmailMedicalQuotation.vue?vue&type=template&id=1fb98e6a"
import script from "./EmailMedicalQuotation.vue?vue&type=script&lang=js"
export * from "./EmailMedicalQuotation.vue?vue&type=script&lang=js"
import style0 from "./EmailMedicalQuotation.vue?vue&type=style&index=0&id=1fb98e6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports